// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"InteractiveTooltip_tooltip__mcHWZ","tooltipArrow":"InteractiveTooltip_tooltipArrow___eCCn"};